<template>
  <v-dialog
    :persistent="isRunning"
    content-class="dialog-fixed-top"
    :value="value"
    @input="(v) => v || $emit('input', null)"
    :max-width="600"
  >
    <v-card>
      <v-toolbar class="card-bar">
        <v-toolbar-title>
          Reenviando {{ withRawdataCount }} heartbeats com rawdata
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-switch v-model="forceIfDuplicate" label="Force if duplicate" />
        <!-- <v-switch v-model="ignoreHardGap" label="Ignore hard gap" /> -->
      </v-card-text>
      <v-card-text>
        <v-progress-linear
          v-model="pct"
          height="25"
          striped
          color="deep-orange"
        >
          <strong>{{ Math.ceil(pct) }}%</strong>
        </v-progress-linear>
      </v-card-text>
      <v-card-actions class="pa-6">
        <v-btn text large @click="cancel" v-if="!isDone">
          Cancelar
        </v-btn>
        <v-spacer />
        <OHoldToConfirm
          class="ma-0 px-4"
          style="height: 48px"
          large
          color="error"
          v-if="!isRunning && !isDone"
          @confirmed="start"
        >
          Iniciar
        </OHoldToConfirm>
        <v-btn text large @click="cancel" v-if="isDone">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Heartbeat } from '@/models'
import OHoldToConfirm from 'oderon-vue/cpts/OHoldToConfirm'

function hasRawdata(hb) {
  return hb.summary.rawDataLength > 0
}

export default {
  components: {
    OHoldToConfirm
  },
  props: {
    value: {},
    list: { type: Array }
  },
  data() {
    return this.reset()
  },
  computed: {
    pct() {
      return Math.ceil((100 * this.sent) / this.withRawdataCount) || 0
    }
  },
  watch: {
    list() {
      Object.assign(this, this.reset())
      this.queue = this.list.filter((r) => hasRawdata(r))
      this.withRawdataCount = this.queue.length
    }
  },
  methods: {
    reset() {
      return {
        forceIfDuplicate: false,
        ignoreHardGap: false,
        queue: [],
        withRawdataCount: 0,
        sent: 0,
        isRunning: false,
        isDone: false
      }
    },
    async start() {
      this.isRunning = true
      this.isDone = false

      // this.withRawdataCount = 20
      // this.sent = 0

      // while ( this.sent < this.withRawdataCount ) {
      //   await this.$delay(200)
      //   this.sent++
      // }

      while (this.queue.length > 0) {
        let head = this.queue.shift()
        await this.sendOne(head)
        this.sent++
      }

      this.isRunning = false
      this.isDone = true
    },

    cancel() {
      this.queue.splice(0, this.queue.length)
      this.$emit('input', null)
    },

    async sendOne(hb) {
      // await this.$delay(500)

      await Heartbeat.resend(hb.id, {
        forceIfDuplicate: this.forceIfDuplicate,
        ignoreHardGap: this.ignoreHardGap
        // forceIfMaxQueue: false,
        // targetOrgId
      })
    }
  }
}
</script>
